"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilestoneRepository = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Config_1 = require("../Config");
const observable_1 = require("../observable");
const CrudRepository_1 = require("./CrudRepository");
class MilestoneRepository extends CrudRepository_1.CrudRepository {
    constructor(env) {
        super(env || Config_1.Build5Env.PROD, interfaces_1.PublicCollections.MILESTONE);
        this.getTopMilestonesLive = () => {
            const url = (0, Config_1.getTopMilestonesUrl)(this.env);
            return (0, observable_1.fetchLive)(this.env, url);
        };
    }
}
exports.MilestoneRepository = MilestoneRepository;
